import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicRoute = ({ children }) => {
    console.log('[PublicRoute Debug] Entering PublicRoute');
    
    const authContext = useAuth();
    console.log('[PublicRoute Debug] useAuth() returned:', authContext);

    const { user, loading, getRoleDashboard } = authContext || {};

    console.log('[PublicRoute Debug] Auth state:', { user, loading });

    if (loading) {
        console.log('[PublicRoute Debug] Loading is true, rendering loader');
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1a3884]"></div>
            </div>
        );
    }

    if (user) {
        const dashboardUrl = typeof getRoleDashboard === 'function' ? getRoleDashboard() : '/dashboard';
        console.log('[PublicRoute Debug] User is authenticated, redirecting to dashboard:', dashboardUrl);
        return <Navigate to={dashboardUrl} replace />;
    }

    console.log('[PublicRoute Debug] User not authenticated, rendering children');
    return children;
};

export default PublicRoute;
